import type { MouseEvent } from 'react';

function smoothScrollToTop() {
  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  window.scrollTo({ top: 0, behavior: prefersReducedMotion ? 'auto' : 'smooth' });
}

/**
 * Click handler for Home / logo links.
 * When already on the home route, prevent the no-op navigation and smooth-scroll
 * to the top. On any other route, let the router <Link> navigate to "/" normally
 * (the Layout scroll-reset hook handles scrolling to the top after navigation).
 */
export function handleHomeClick(event: MouseEvent<HTMLElement>) {
  if (window.location.pathname === '/') {
    event.preventDefault();
    smoothScrollToTop();
  }
}

export function scrollToTop(event?: MouseEvent<HTMLElement>) {
  event?.preventDefault();
  smoothScrollToTop();
}
